import { Box } from '@mui/material';
import { useContext } from 'react';

import { UserContext } from '~/auth/userContext';

const CurrencySymbol: React.FC = () => {
  const { currencyCode } = useContext(UserContext);
  return (
    <Box textOverflow="ellipsis" overflow="hidden">
      {currencyCode === 'GBP' ? '£' : '$'}
    </Box>
  );
};

export default CurrencySymbol;
